import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import Constants from '../helpers/Constants';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: () => import('../pages/Root.vue'),
    name: 'root',
  },
  {
    path: '/analytics',
    component: () => import('../pages/Analytics.vue'),
    name: 'analytics',
  },
  {
    path: '/destination_analytics',
    component: () => import('../pages/DestinationAnalytics.vue'),
    name: 'statistics',
  },
  {
    path: '/userManagement',
    component: () => import('../pages/UserManagement.vue'),
  },
  {
    path: '/customerManagement',
    component: () => import('../pages/CustomerPage.vue'),
  },
  {
    path: '/bigqueryManagement',
    component: () => import('../pages/BigQueryTable.vue'),
  },
  {
    path: '/logVersionManagement',
    component: () => import('../pages/LogVersion.vue'),
  },
  {
    path: '/dashboardManagement',
    component: () => import('../pages/DashboardManagement.vue'),
  },
  {
    path: '/tripbits_videos',
    component: () => import('../pages/VideoAssets.vue'),
  },
  {
    path: '/exports',
    component: () => import('../pages/Exports.vue'),
  },
  {
    path: '/history',
    component: { render: (h) => h('div') },
    beforeEnter: (to, from, next) => {
      const userAbilities = store.getters['auth/abilities'] || [];

      if (userAbilities.includes(Constants.ABILITY.CUSTOMER)) {
        next({ path: '/' });
        return;
      }

      if (process.env.VUE_APP_HISTORY_URL) {
        window.location.href = process.env.VUE_APP_HISTORY_URL;
      }

      next(false);
    },
  },
  {
    path: '/tailNumbersReport',
    component: () => import('../pages/TailNumbersReport.vue'),
  },
  {
    path: '/logsTracking',
    component: () => import('../pages/LogsTracking.vue'),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
